import { render } from "./Electro3Component.vue?vue&type=template&id=64d8559e"
import script from "./Electro3Component.vue?vue&type=script&lang=js"
export * from "./Electro3Component.vue?vue&type=script&lang=js"

import "./Electro3Component.vue?vue&type=style&index=0&id=64d8559e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__